import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mtl_cart")) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("mtl_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, size, quantity = 1, unitPrice, color) => {
    const price = unitPrice != null ? unitPrice : product.price;
    setItems((prev) => {
      const key = `${product.id}-${size || ""}-${color || ""}`;
      const existing = prev.find((i) => i.key === key);
      if (existing) {
        return prev.map((i) => (i.key === key ? { ...i, quantity: i.quantity + quantity } : i));
      }
      const image = (color && product.color_images?.[color]) || product.images?.[0] || "";
      return [...prev, {
        key, product_id: product.id, name: product.name, price,
        image, size: size || null, color: color || null, quantity,
      }];
    });
  };

  const updateQty = (key, quantity) => {
    if (quantity < 1) return removeItem(key);
    setItems((prev) => prev.map((i) => (i.key === key ? { ...i, quantity } : i)));
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clearCart = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clearCart, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}
